// Abandoned Tab Message - Recover lost attention with rotating messages
// FIXED VERSION - Cart messages ONLY show when items in cart
// ENHANCED: Prioritize grand total detection over item summation

(function() {
  'use strict';
  
  // =============================================
  // CONFIGURATION - Customize these messages
  // =============================================
  const config = {
    originalTitle: document.title,
    
    // Regular abandoned messages (shown when cart is empty)
    abandonedMessages: [
      "Don't leave! 😢",
      "We're still here! ",
      "Miss us already?",
      "Come back!",
    ],
    
    // Urgency messages (shown when more than 30€ needed for free shipping)
    urgencyMessages: [
      "Hey, you! 🫵",
      "It's almost yours!",
    ],
    
    // Free shipping threshold settings
    freeShipping: {
      enabled: true,
      threshold: 100, // 100€
      showBelow: 30.01, // Only show amount message when remaining is less than this
      amountMessage: "€{amount} to free shipping", // {amount} will be replaced with calculated amount
      achievedMessage: "🎉 FREE SHIPPING!", // Shown when threshold is reached/exceeded
      currency: "€"
    },
    
    // Message shown when they return
    returnMessage: "👋 Welcome back Madman!",
    
    // Rotation interval in milliseconds (3000 = 3 seconds)
    rotationInterval: 3000,
    
    // Debug mode - set to true to see console logs
    debug: true,
    
    // Cart awareness
    cartAware: true
  };

  // =============================================
  // CART DETECTION
  // =============================================
  
  function getCartCount() {
    try {
      if (config.debug) console.log('🔍 Checking for cart items...');
      
      // METHOD 1: Check for Shopify cart in the page
      if (window.Shopify && window.Shopify.cart) {
        let count = window.Shopify.cart.item_count;
        if (typeof count === 'number' && count > 0) {
          if (config.debug) console.log(`✅ Found cart count ${count} from Shopify object`);
          return count;
        }
      }
      
      // METHOD 2: Common Shopify cart count selectors
      const selectors = [
        '.cart-count',
        '.cart__count',
        '.cart-item-count',
        '.cart-counter',
        '[data-cart-count]',
        '[data-cart-item-count]',
        '.ajaxcart__qty',
        '.cart-icon__count',
        '.cart-badge',
        '.cart-link__count',
        '.site-header__cart-count',
        '#CartCount',
        '.cart-popup__count',
        '.cart__quantity',
        '.cart-icon__count-bubble',
        '[data-cart-count-bubble]',
        '.cart-count-bubble',
        '.cart__badge',
        '.cart-icon__badge',
        '.header__cart-count'
      ];
      
      // Try each selector
      for (let selector of selectors) {
        let elements = document.querySelectorAll(selector);
        for (let el of elements) {
          let text = el.innerText || el.textContent;
          if (text) {
            // Extract only the first number from the text
            let match = text.match(/\d+/);
            if (match) {
              let count = parseInt(match[0], 10);
              if (!isNaN(count) && count > 0) {
                if (config.debug) console.log(`✅ Found cart count ${count} using selector: ${selector}`);
                return count;
              }
            }
          }
        }
      }
      
      // METHOD 3: Check localStorage for cart data
      try {
        let cartData = localStorage.getItem('cart') || localStorage.getItem('shopify-cart');
        if (cartData) {
          let cart = JSON.parse(cartData);
          if (cart.item_count && cart.item_count > 0) {
            if (config.debug) console.log(`✅ Found cart count ${cart.item_count} in localStorage`);
            return cart.item_count;
          }
        }
      } catch (e) {}
      
      if (config.debug) console.log('ℹ️ No cart items found');
      return 0;
      
    } catch (e) {
      if (config.debug) console.log('Error checking cart:', e);
      return 0;
    }
  }
  
  // =============================================
  // ENHANCED CART TOTAL PRICE DETECTION
  // =============================================
  
  function getCartTotal() {
    try {
      if (config.debug) console.log('💰 Checking cart total price...');
      
      // METHOD 1: Check for Shopify cart object (MOST RELIABLE)
      if (window.Shopify && window.Shopify.cart) {
        // Try different possible property names
        let total = window.Shopify.cart.total_price || window.Shopify.cart.total || window.Shopify.cart.subtotal_price || window.Shopify.cart.subtotal;
        if (typeof total === 'number') {
          // Shopify total_price is usually in cents, but check if it's already in euros
          let totalInEuros = total > 1000 ? total / 100 : total; // Assume >1000 means cents
          if (totalInEuros > 0) {
            if (config.debug) console.log(`✅ Found cart total €${totalInEuros.toFixed(2)} from Shopify object (raw: ${total})`);
            return totalInEuros;
          }
        }
      }
      
      // METHOD 2: Check for theme's cart object
      if (window.theme && window.theme.cart) {
        let total = window.theme.cart.total_price || window.theme.cart.total || window.theme.cart.subtotal_price || window.theme.cart.subtotal;
        if (typeof total === 'number') {
          let totalInEuros = total > 1000 ? total / 100 : total;
          if (totalInEuros > 0) {
            if (config.debug) console.log(`✅ Found cart total €${totalInEuros.toFixed(2)} from theme object`);
            return totalInEuros;
          }
        }
      }
      
      // METHOD 3: Check for common global cart variables
      if (window.cart) {
        let total = window.cart.total_price || window.cart.total || window.cart.subtotal_price || window.cart.subtotal;
        if (typeof total === 'number') {
          let totalInEuros = total > 1000 ? total / 100 : total;
          if (totalInEuros > 0) {
            if (config.debug) console.log(`✅ Found cart total €${totalInEuros.toFixed(2)} from window.cart`);
            return totalInEuros;
          }
        }
      }
      
      // METHOD 4: Look for cart total elements in the DOM (EXPANDED)
      let totalFromElement = getTotalFromElement();
      if (totalFromElement > 0) {
        return totalFromElement;
      }
      
      // METHOD 5: Try to extract total from any element containing "total" in a cart container
      let totalFromAnyElement = getTotalFromAnyElement();
      if (totalFromAnyElement > 0) {
        return totalFromAnyElement;
      }
      
      // METHOD 6: Try to get from meta tags or data attributes
      let metaTotal = getTotalFromMeta();
      if (metaTotal > 0) {
        if (config.debug) console.log(`✅ Found cart total €${metaTotal.toFixed(2)} from meta/data`);
        return metaTotal;
      }
      
      // METHOD 7: FALLBACK - Calculate from individual cart items (only if everything else fails)
      if (config.debug) console.log('⚠️ No direct total found, falling back to item summation');
      let itemTotal = calculateTotalFromItems();
      if (itemTotal > 0) {
        if (config.debug) console.log(`✅ Calculated cart total €${itemTotal.toFixed(2)} from line items`);
        return itemTotal;
      }
      
      if (config.debug) console.log('ℹ️ Could not determine cart total');
      return 0;
      
    } catch (e) {
      if (config.debug) console.log('Error checking cart total:', e);
      return 0;
    }
  }
  
  // Enhanced function to find total from specific elements
  function getTotalFromElement() {
    // Comprehensive list of total selectors
    const totalSelectors = [
      // Standard totals
      '.cart__total',
      '.cart-total',
      '.cart-subtotal',
      '.cart__subtotal',
      '[data-cart-total]',
      '[data-cart-subtotal]',
      '.total-price',
      '.cart-price',
      '.ajaxcart__subtotal',
      '#CartTotal',
      '.cart-popup__total',
      '.cart__footer .totals',
      '.cart__subtotal-price',
      '.cart-subtotal__price',
      '.cart__total-price',
      '.cart__total-amount',
      '.cart-total-price',
      '.subtotal-price',
      '.cart__subtotal-amount',
      '[data-cart-subtotal-price]',
      '[data-cart-total-price]',
      '.cart__subtotal-value',
      '.cart__total-value',
      '.cart__checkout .price',
      '.cart__buttons .price',
      '.cart-subtotal__price',
      '.cart-summary__total',
      '.summary__total',
      '.order-summary__total',
      '.order-summary__subtotal',
      '.cart__row--total .cart__cell--total',
      '.cart__row .cart__total',
      '.cart-row--total .cart-row__total',
      '.cart-subtotal__amount',
      '.cart-total__amount',
      
      // Additional common patterns
      '.total-row .amount',
      '.total .money',
      '.subtotal .money',
      '.cart-total-amount',
      '.cart-subtotal-amount',
      '.order-total',
      '.order-subtotal',
      '.cart__total-money',
      '.cart-total-money',
      '.cart__subtotal-money',
      '[id*="cart-total"]',
      '[id*="cart-subtotal"]',
      '[class*="cart-total"]:not([class*="item"])',
      '[class*="cart-subtotal"]:not([class*="item"])',
      
      // Checkout button area
      '.checkout-button .price',
      '.checkout-btn .amount',
      '.cart__checkout .cart__total',
      
      // Cart drawer/popup totals
      '.cart-drawer__total',
      '.cart-drawer__subtotal',
      '.ajax-cart__total',
      '.ajax-cart__subtotal'
    ];
    
    for (let selector of totalSelectors) {
      let elements = document.querySelectorAll(selector);
      for (let el of elements) {
        let text = el.innerText || el.textContent;
        if (text) {
          // Try multiple price patterns
          let patterns = [
            /[€$£]\s*(\d+[.,]\d{2})/, // €49.00, $49.00
            /(\d+[.,]\d{2})\s*[€$£]/, // 49,00€
            /[€$£]\s*(\d+)/, // €49
            /(\d+)\s*[€$£]/, // 49€
            /total[:\s]*[€$£]?\s*(\d+[.,]\d{2})/i, // Total: €49.00
            /subtotal[:\s]*[€$£]?\s*(\d+[.,]\d{2})/i, // Subtotal: €49.00
            /(\d+[.,]\d{2})\s*(?:€|$|£)/ // 49.00 €
          ];
          
          for (let pattern of patterns) {
            let match = text.match(pattern);
            if (match) {
              let priceStr = match[1].replace(',', '.');
              let total = parseFloat(priceStr);
              if (!isNaN(total) && total > 0 && total < 10000) { // Sanity check
                if (config.debug) console.log(`✅ Found cart total €${total.toFixed(2)} from element: ${selector} (text: "${text}")`);
                return total;
              }
            }
          }
        }
      }
    }
    return 0;
  }
  
  // Fallback: scan any element that might contain the total
  function getTotalFromAnyElement() {
    try {
      // Identify a cart container
      const cartContainers = [
        '.cart',
        '.cart__container',
        '.ajaxcart',
        '.cart-drawer',
        '.cart-content',
        '#cart',
        '.cart-wrapper',
        '.cart__body',
        '.cart-items',
        '.cart__footer',
        '.cart-summary',
        '.order-summary'
      ];
      
      let cartArea = null;
      for (let sel of cartContainers) {
        cartArea = document.querySelector(sel);
        if (cartArea) break;
      }
      if (!cartArea) cartArea = document.body; // fallback to whole page
      
      // Find all elements that contain price-like numbers and the word "total"
      let candidates = cartArea.querySelectorAll('*');
      for (let el of candidates) {
        let text = el.innerText || el.textContent;
        if (text && /total|subtotal|gesamt|summe/i.test(text)) {
          let match = text.match(/[€$£]?\s*(\d+[.,]\d{2})\s*[€$£]?/);
          if (match) {
            let priceStr = match[1].replace(',', '.');
            let total = parseFloat(priceStr);
            if (!isNaN(total) && total > 0 && total < 10000) {
              if (config.debug) console.log(`✅ Found cart total €${total.toFixed(2)} from element with "total":`, el);
              return total;
            }
          }
        }
      }
      return 0;
    } catch (e) {
      return 0;
    }
  }
  
  function getTotalFromMeta() {
    try {
      let metaSelectors = [
        'meta[property="cart:total"]',
        'meta[name="cart-total"]',
        'meta[itemprop="price"]',
        '[data-cart-total-value]',
        '[data-cart-subtotal-value]'
      ];
      for (let selector of metaSelectors) {
        let el = document.querySelector(selector);
        if (el) {
          let content = el.getAttribute('content') || el.getAttribute('value') || el.getAttribute('data-value');
          if (content) {
            let match = content.match(/\d+[.,]\d{2}/);
            if (match) {
              let total = parseFloat(match[0].replace(',', '.'));
              if (!isNaN(total) && total > 0) return total;
            }
          }
        }
      }
      return 0;
    } catch (e) {
      return 0;
    }
  }
  
  // Keep item summation as last resort (but simplified)
  function calculateTotalFromItems() {
    try {
      // Try localStorage as it's usually reliable
      let cartData = localStorage.getItem('cart') || localStorage.getItem('shopify-cart');
      if (cartData) {
        let cart = JSON.parse(cartData);
        if (cart.items && cart.items.length > 0) {
          let total = 0;
          for (let item of cart.items) {
            let price = item.price || item.line_price || 0;
            let quantity = item.quantity || 1;
            if (price > 1000) price = price / 100;
            total += price * quantity;
          }
          if (total > 0) {
            if (config.debug) console.log(`✅ Calculated cart total €${total.toFixed(2)} from localStorage (${cart.items.length} items)`);
            return total;
          }
        }
      }
      
      // Fallback to DOM item summation (simplified)
      let total = 0;
      let itemElements = document.querySelectorAll('.cart-item, .cart__item, .ajaxcart__row, [data-cart-item]');
      for (let item of itemElements) {
        let priceEl = item.querySelector('[class*="price"], [class*="Price"]');
        if (priceEl) {
          let text = priceEl.innerText;
          let match = text.match(/[€$£]?\s*(\d+[.,]\d{2})/);
          if (match) {
            total += parseFloat(match[1].replace(',', '.'));
          }
        }
      }
      if (total > 0) {
        if (config.debug) console.log(`✅ Calculated cart total €${total.toFixed(2)} from ${itemElements.length} DOM items`);
        return total;
      }
      
      return 0;
    } catch (e) {
      return 0;
    }
  }

  // =============================================
  // MESSAGE SELECTION - Dynamic based on cart state
  // =============================================
  
  function getMessagesToShow() {
    let cartCount = getCartCount();
    
    if (config.cartAware && cartCount > 0) {
      if (config.debug) console.log(`🎯 SHOWING CART MESSAGES (${cartCount} items in cart)`);
      
      let cartCountMessage = `🛒 You have ${cartCount} item${cartCount > 1 ? 's' : ''} in your cart!`;
      let cartTotal = getCartTotal();
      let remainingForFreeShipping = cartTotal > 0 ? config.freeShipping.threshold - cartTotal : null;
      
      let messagesToShow = [];
      
      if (config.freeShipping.enabled && cartTotal > 0) {
        if (remainingForFreeShipping <= 0) {
          messagesToShow = [cartCountMessage, config.freeShipping.achievedMessage];
          if (config.debug) console.log(`🎉 Free shipping achieved! (Total €${cartTotal.toFixed(2)})`);
        } else if (remainingForFreeShipping < config.freeShipping.showBelow) {
          let formattedAmount = remainingForFreeShipping.toFixed(2);
          let amountMessage = config.freeShipping.amountMessage.replace('{amount}', formattedAmount);
          messagesToShow = [cartCountMessage, amountMessage];
          if (config.debug) console.log(`🚚 Close to free shipping (€${formattedAmount} needed)`);
        } else {
          messagesToShow = [
            config.urgencyMessages[0],
            config.urgencyMessages[1],
            cartCountMessage
          ];
          if (config.debug) console.log(`⏱️ Far from free shipping (€${remainingForFreeShipping.toFixed(2)} needed)`);
        }
      } else {
        messagesToShow = [cartCountMessage];
      }
      
      if (config.debug) {
        console.log('📋 Messages to show:');
        messagesToShow.forEach((msg, idx) => console.log(`   ${idx+1}. ${msg}`));
      }
      return messagesToShow;
    }
    
    if (config.debug) console.log('📝 Showing regular messages only (cart is empty)');
    return config.abandonedMessages;
  }

  // =============================================
  // MESSAGE ROTATION (unchanged)
  // =============================================
  
  let attentionRecovered = false;
  let timeoutId = null;
  let rotationIntervalId = null;
  let messageIndex = 0;
  let currentMessages = [];
  let lastCartCount = 0;
  let lastCartTotal = 0;
  
  function checkCartAndUpdate() {
    if (!document.hidden || !config.cartAware) return;
    
    let currentCartCount = getCartCount();
    let currentCartTotal = getCartTotal();
    
    if (currentCartCount !== lastCartCount || Math.abs(currentCartTotal - lastCartTotal) > 0.01) {
      if (config.debug) {
        console.log('📊 Cart changed:');
        console.log('   Items:', lastCartCount, '→', currentCartCount);
        console.log('   Total:', lastCartTotal.toFixed(2), '→', currentCartTotal.toFixed(2));
      }
      lastCartCount = currentCartCount;
      lastCartTotal = currentCartTotal;
      
      let newMessages = getMessagesToShow();
      if (JSON.stringify(currentMessages) !== JSON.stringify(newMessages)) {
        currentMessages = newMessages;
        messageIndex = 0;
        if (config.debug) console.log('🔄 Messages updated!');
      }
    }
  }

  function startRotation() {
    if (rotationIntervalId) clearInterval(rotationIntervalId);
    
    lastCartCount = getCartCount();
    lastCartTotal = getCartTotal();
    currentMessages = getMessagesToShow();
    messageIndex = 0;
    
    if (config.debug) {
      console.log('🔥 Starting message rotation');
      console.log('Cart count:', lastCartCount);
      console.log('Cart total: €' + lastCartTotal.toFixed(2));
      if (lastCartCount > 0) {
        let remaining = config.freeShipping.threshold - lastCartTotal;
        console.log('Remaining for free shipping: €' + (remaining > 0 ? remaining.toFixed(2) : '0.00'));
      }
    }
    
    if (currentMessages.length === 0) currentMessages = ["Don't forget us! 👋"];
    
    document.title = currentMessages[0];
    messageIndex = 1;
    
    rotationIntervalId = setInterval(() => {
      if (document.hidden) {
        checkCartAndUpdate();
        if (currentMessages.length > 0) {
          if (currentMessages.length === 1) {
            document.title = currentMessages[0];
          } else {
            if (messageIndex >= currentMessages.length) messageIndex = 0;
            document.title = currentMessages[messageIndex];
            messageIndex++;
          }
        }
      }
    }, config.rotationInterval);
  }

  function stopRotation() {
    if (rotationIntervalId) {
      clearInterval(rotationIntervalId);
      rotationIntervalId = null;
    }
  }

  function handleVisibilityChange() {
    if (document.hidden) {
      if (config.debug) console.log('📤 Tab abandoned - starting message rotation');
      if (timeoutId) clearTimeout(timeoutId);
      startRotation();
      attentionRecovered = false;
    } else {
      if (config.debug) console.log('📥 Tab active - stopping rotation');
      stopRotation();
      if (!attentionRecovered) {
        document.title = config.returnMessage;
        timeoutId = setTimeout(() => {
          document.title = config.originalTitle;
          attentionRecovered = true;
          timeoutId = null;
        }, 2000);
      }
    }
  }

  function init() {
    config.originalTitle = document.title;
    
    if (config.debug) {
      console.log('🚀 Abandoned Tab Message initializing...');
      console.log('Free shipping threshold: €' + config.freeShipping.threshold);
    }
    
    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    window.addEventListener('focus', function() {
      if (!attentionRecovered && !document.hidden) {
        stopRotation();
        document.title = config.returnMessage;
        setTimeout(() => {
          document.title = config.originalTitle;
          attentionRecovered = true;
        }, 2000);
      }
    });
    
    window.addEventListener('blur', function() {
      if (document.hidden && !rotationIntervalId) {
        startRotation();
        attentionRecovered = false;
      }
    });
    
    if (config.cartAware) {
      setInterval(() => {
        if (document.hidden) {
          checkCartAndUpdate();
        } else {
          lastCartCount = getCartCount();
          lastCartTotal = getCartTotal();
        }
      }, 2000);
      
      setTimeout(() => {
        lastCartCount = getCartCount();
        lastCartTotal = getCartTotal();
        if (lastCartCount > 0 && config.debug) {
          console.log(`🛒 INITIAL CART: ${lastCartCount} items (€${lastCartTotal.toFixed(2)})`);
        }
      }, 500);
    }
    
    if (config.debug) console.log('✅ Initialization complete');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();